import { Button, Link, Popover, PopoverContent, PopoverLauncher, Typography } from '@vp/swan';
import { __ } from '@99designs/i18n';

export function DesignLive() {
    return (
        <Popover position="bottom" display="inline">
            <PopoverLauncher>
                <Link
                    render={(p, ref) => (
                        <Button ref={ref} skin="link" className={p.className} {...p} />
                    )}
                >
                    {__('a live video call')}
                </Link>
            </PopoverLauncher>
            <PopoverContent>
                <Typography fontSkin="title-item" mb={4}>
                    {__('Live video call')}
                </Typography>
                {__(
                    'Speak to your designer in a 30-minute video call. Provide feedback while they work on your design in real time. Up to three revisions available after your live session. No additional fee.'
                )}
            </PopoverContent>
        </Popover>
    );
}
